import { SIDEBAR_GROUPS } from '@/components/layout/sidebar';
import { usePermissions } from './use-permissions';

/** Where to send a user after login when no explicit `from` location is set.
 *
 *  Walks the sidebar groups in their declared (top-to-bottom) order and
 *  returns the first nav item the user can access — so a driver with only
 *  "View Own" on Dispatch Report lands on Dispatch Jobs Report instead of
 *  bouncing to /dashboard and seeing Access denied.
 *
 *  Fallback: `/profile`, which is always accessible to authenticated users.
 */
export function useDefaultHomePath(): string {
  const { can } = usePermissions();
  // There used to be an `isAdmin` shortcut straight to /dashboard. It was
  // both redundant and wrong: anyone who can see Dashboard gets it from the
  // walk below anyway (it is the first item), and anyone who cannot was sent
  // to a page that then refused them.
  for (const g of SIDEBAR_GROUPS) {
    for (const item of g.items) {
      if (!item.slug || can(item.slug, 'view')) return item.to;
    }
  }
  return '/profile';
}
